import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Checkbox, tokens } from '@hotjar/hotsauce';

export const CheckboxItemStyles = {
  Checkbox: styled('div')`
    width: 100%;
    position: relative;
    display: inline-block;
  `,
  CheckboxInput: styled(Checkbox)`
    margin: 0;
    float: right;
  `,
  CheckboxLabel: styled('label')<{ selected: boolean; disabled?: boolean }>`
    width: 100%;
    background: ${tokens.color.white};
    padding: ${tokens.spacer.x2} ${tokens.spacer.x2} ${tokens.spacer.x2pt5} ${tokens.spacer.x2};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    border: ${(props) =>
      props.selected
        ? `1px solid ${tokens.color.ui_border_active}`
        : `1px solid ${tokens.color.ui_border}`};
    ${tokens.elevation(4)};
    border-radius: ${tokens.radius.m};
    text-transform: none;
    margin-bottom: ${tokens.spacer.x2};
    display: block;

    &:focus,
    &:hover {
      ${({ disabled }) =>
        !disabled &&
        css`
          border: 1px solid ${tokens.color.ui_border_alt};
        `}
    }
  `,
  CheckboxFirstRow: styled('div')`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: ${tokens.spacer.x0pt5};
  `,
  CheckboxTitleWrapper: styled('div')`
    display: flex;
    align-items: center;
  `,
  CheckboxTitle: styled('p')<{ disabled?: boolean }>`
    ${tokens.text('header5')}
    margin-left: ${tokens.spacer.x1};
    margin-bottom: 0;
    color: ${({ disabled }) => (disabled ? tokens.color.text_disabled : tokens.color.text_default)};
  `,
};
